// headers.js
const aggregateHeaders = async (config) => {
    // Nota: sessionStorage suele ser síncrono, pero mantengo el await
    // por si usas una librería wrapper asíncrona.

    const identity = await sessionStorage.getItem("identityClientI");
    if (identity) {
        // Modificamos config.headers directamente
        config.headers['x-identity'] = identity;
    }

    const host = await sessionStorage.getItem("identityClientH");
    if (host) {
        config.headers['x-host'] = host;
    }

    const auth_token = await sessionStorage.getItem("token");
    if (auth_token) {
        console.log("AXIOS: auth_token agregado a config");
        config.headers['Authorization'] = "Bearer " + auth_token;
    } else {
        console.log("AXIOS: no hay token");
    }

    return config;
}

export default aggregateHeaders;